import React, { useState, useRef, useEffect } from "react";
import upArrow from "assets/images/organisationProfile/setup/select arrow.svg";
import upArrowDark from "assets/images/organisationProfile/setup/selectArowdark.svg";
import { countries } from "constants/setup/countries";
import useTheme from "hooks/observer";

import "./selectCountry.scss";

const SelectCountry = ({
  selectedCountry,
  onSelectCountry,
  label = "Location",
  data = countries,
  width = "100%"
}) => {
  const [countryDropdownOpen, setCountryDropdownOpen] = useState(false);
  const theme = useTheme();
  const countryDropdownRef = useRef(null);

  const toggleCountryDropdown = () => {
    setCountryDropdownOpen((prev) => !prev);
  };

  const handleCountrySelect = (country) => {
    onSelectCountry(country);
    setCountryDropdownOpen(false);
  };

  const getSelectedStyle = (selectedValue, item) => {
    return selectedValue === item
      ? {
          color: "var(--text-grey-strong)",
          fontSize: "16px",
          fontWeight: "600",
          lineHeight: "24px"
        }
      : {};
  };

  const arrow = theme === "light" ? upArrow : upArrowDark;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        countryDropdownRef.current &&
        !countryDropdownRef.current.contains(event.target)
      ) {
        setCountryDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="form-group">
      <label htmlFor="countrySelect" className="form-label">
        {label}
      </label>
      <div
        id="countrySelect"
        className="form-select"
        onClick={toggleCountryDropdown}
        ref={countryDropdownRef}
        style={{ width: width ? width : "93%" }}
      >
        <p
          style={
            selectedCountry === "Select reason for leaving"
              ? { color: "var(--text-placeholder)" }
              : { color: "var(--text-grey-strong)" }
          }
        >
          {selectedCountry || "Select a country"}
        </p>
        <img src={arrow} alt="select" />
        {countryDropdownOpen && (
          <div
            className="dropdownList countryDropdown"
            id="countryDropdown"
            onClick={(e) => e.stopPropagation()}
          >
            {data.map((country, index) => (
              <div
                key={index}
                className="dropdownItem"
                onClick={() => handleCountrySelect(country)}
                style={getSelectedStyle(selectedCountry, country)}
              >
                {country}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectCountry;
